import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Transition from 'react-transition-group/Transition'
import './Slide.css'

class Slide extends Component {

    render(children) {

        const duration = 300

        const defaultStyle = {
            transition: `opacity ${duration}ms ease-in, top ${duration}ms ease-in`,
            opacity: 0,
            top: `200%`
        }

        
        const transitionStyles = {
            entering: { opacity: 0, top: `${this.props.backwards ? -100 : 100}%` },
            entered: { opacity: 1, top: `0%` },
            exiting: { opacity: 1, top: `0%` },
            exited: { opacity: 0, top: `${this.props.backwards ? 100 : -100}%` }
        }

        return (
            <Transition in={this.props.in} timeout={duration}>
                { state => (
                    <div style={{...defaultStyle, ...transitionStyles[state]}} className='Slide'>
                        { children }
                    </div>
                )}
            </Transition>
        )

    }
}

Slide.propTypes = {
    in: PropTypes.bool.isRequired,
    backwards: PropTypes.bool
}

export default Slide


// WEBPACK FOOTER //
// ./src/components/Slide.js